//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';

import { IStatBubbleComparisonStat } from '@components/molecules/stat-bubble/StatBubble';
import {
  ChipContainer,
  StyledChip,
} from '@components/molecules/stat-bubble/StatBubbleStyles';
import { getChipType } from '@components/molecules/stat-bubble/utils';
import { SmallTooltip } from '@components/molecules/tooltip/Tooltip';
import { isDefined } from '@utils/filterPredicates';
import { ITrackableComponent, withTracking } from '@utils/withTracking';

interface StatComparisonChipProps extends ITrackableComponent {
  comparisonStat?: IStatBubbleComparisonStat;
}

export const StatComparisonChip = ({
  comparisonStat,
  trackingId,
}: StatComparisonChipProps) => {
  if (!comparisonStat) {
    return null;
  }

  return (
    <SmallTooltip
      content={comparisonStat.tooltipText}
      isDisabled={!isDefined(comparisonStat.tooltipText)}
      placement='right'
      target={
        <TrackedChipContainer trackingId={trackingId}>
          <StyledChip
            chipType={getChipType(comparisonStat.trendingIcon)}
            decorativeIcon={comparisonStat.trendingIcon}
            size='large'
            text={comparisonStat.percentage}
          />
        </TrackedChipContainer>
      }
    />
  );
};

const TrackedChipContainer = withTracking(ChipContainer);
